import { Component, OnInit } from '@angular/core';
import { IndicatorsSearchToolbarModel } from '../../../../models/indicators-search-toolbar-model.model';
import { IndicatorsService } from '../../../../services/indicators/indicators.service';
import { QFilterModel } from '../../../../models/qfilter.model';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';
import { SearchToolbarModelFactoryService } from '../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import { AnalyticsService } from '../../../../services/analytics/analytics.service';
import { LoyaltyChart } from '../../../../models/loyalty-chart-config.model';
import { NumberKMPipe } from '../../../../pipes/numberKMPipe';

@Component({
  selector: 'app-customer-category-importance',
  templateUrl: './customer-category-importance.component.html',
  styleUrls: ['./customer-category-importance.component.css']
})

// Pagina 18
export class CustomerCategoryImportanceComponent implements OnInit {
  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
  public translations: any;
  public departmentInvoiceChart: LoyaltyChart;
  public divisionDepartmentInvoiceChart: LoyaltyChart;
  public data: QFilterModel;

  constructor (
    private indicatorService: IndicatorsService,
    private searchModelFactory: SearchToolbarModelFactoryService,
    private svcAnalytics: AnalyticsService,
    private translate: TranslateService
  ) {

  }

  ngOnInit() {
    this.translate.get([
      'categoryImportance.departmentInvoiceTitle',
      'categoryImportance.divisionDepartmentInvoiceTitle',
      'categoryImportance.fatturato_totale',
      'categoryImportance.percentuale_fatturato'
    ]).subscribe((t) => {
      this.translations = {
        departmentInvoiceTitle: t['categoryImportance.departmentInvoiceTitle'],
        divisionDepartmentInvoiceTitle: t['categoryImportance.divisionDepartmentInvoiceTitle'],
        fatturato_totale: t['categoryImportance.fatturato_totale'],
        percentuale_fatturato: t['categoryImportance.percentuale_fatturato']
      };
      this.initCharts();
    });
  }

  initCharts() {
    this.departmentInvoiceChart = new LoyaltyChart('bar');
    this.departmentInvoiceChart.options.xAxis = {type: 'category'};
    this.departmentInvoiceChart.options.legend = {verticalAlign: 'bottom'};
    this.departmentInvoiceChart.options.legend.enabled = false;
    this.departmentInvoiceChart.options.yAxis = { title: {text: this.translations.fatturato_totale} };

    this.departmentInvoiceChart.options.yAxis.labels = {
      formatter: function () {
        return NumberKMPipe.formatDynamic(this.value, '€');
      }
    };

    this.departmentInvoiceChart.options.tooltip = {
      formatter: function () {
        return NumberKMPipe.formatDynamic(this.y, '€');
      }
    };

    this.divisionDepartmentInvoiceChart = new LoyaltyChart('bar');
    this.divisionDepartmentInvoiceChart.options.plotOptions = {series: {stacking: 'percent'}};
    this.divisionDepartmentInvoiceChart.options.legend = {layout: 'vertical', align: 'right', verticalAlign: 'top'};
    this.divisionDepartmentInvoiceChart.options.yAxis = { title: {text: this.translations.percentuale_fatturato},
      labels: {format: '{value} %'}
    };
    this.divisionDepartmentInvoiceChart.options.tooltip = {
      formatter: function () {
        return NumberKMPipe.formatDynamic(this.y, '€') + ' (' + NumberKMPipe.formatDynamic(this.percentage, '%') + ')';
      }
    };
  }

  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
  }

  searchValueCustomer(data: QFilterModel) {
    this.data = data;

    this.departmentInvoiceInit (data);
    this.ivisionDepartmentInvoiceInit (data);

  }

  resetData() {
    this.data = null;
  }

  departmentInvoiceInit (data) {

    Observable.zip (
      this.indicatorService.getChart('customers.Q136', data, false)
    ).subscribe( ([res]) => {

      let serie0 = res.series[0].serie;
      let serie1 = res.series[1].serie;
      let series: Array<any> = [];

      for (let i = 0; i < serie0.length; i++) {
        series.push ( {name: serie0[i], y: serie1[i], color: '#26437a'} );
      }

      this.departmentInvoiceChart.options.chart.height = series.length * 45;

      if (this.departmentInvoiceChart.instance) {
        while (this.departmentInvoiceChart.instance.series.length > 0) {
          this.departmentInvoiceChart.instance.series[0].remove(true);
        }
      }


      this.departmentInvoiceChart.options.chart.height = 800;
      this.departmentInvoiceChart.options.series = [{ name: this.translations.segmentsInvoiceTitle, colorByPoint: true, data: series }];
      this.departmentInvoiceChart.instance.addSeries(series);

      this.departmentInvoiceChart.instance.update(this.departmentInvoiceChart.options);
      this.departmentInvoiceChart.instance.redraw();

    });
  }

  ivisionDepartmentInvoiceInit (data) {

    Observable.zip (
      this.indicatorService.getChart('customers.Q137', data, false)
    ).subscribe( ([res]) => {

      let serie0 = res.series[0].serie;
      let serie1 = res.series[1].serie;
      let serie2 = res.series[2].serie;
      let colors = res.series[3].serie;
      const xAxis = {
        serie: serie0.filter(function (value, indice, self) {
          return self.indexOf(value) === indice;
        })
      };

      let series: Array<any> = [];
      let index = serie0.length;
      for (let i = 0; i < serie0.length; i++) {
        let elem = series.find(function (elemento) {
          return elemento.name === serie1[i];
        });
        if (typeof elem === 'undefined') {
          series.push({name: serie1[i], data: [serie2[i]], color: colors[(i)]});
          index = index - 1;
        } else {
          elem.data.push(serie2[i]);
        }
      }

      this.divisionDepartmentInvoiceChart.options.chart.height = series.length * 100;

      if (this.divisionDepartmentInvoiceChart.instance) {
        while (this.divisionDepartmentInvoiceChart.instance.series.length > 0) {
          this.divisionDepartmentInvoiceChart.instance.series[0].remove(true);
        }
      }

      this.divisionDepartmentInvoiceChart.options.xAxis.categories = xAxis.serie;
      this.divisionDepartmentInvoiceChart.options.chart.height = 800;

      for (let i = 0; i < series.length; i++) {

        this.divisionDepartmentInvoiceChart.instance.addSeries(series[i]);
      }

      this.divisionDepartmentInvoiceChart.instance.update(this.divisionDepartmentInvoiceChart.options);
      this.divisionDepartmentInvoiceChart.instance.redraw();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-value/customer-category-importance/customer-category-importance.component.ts